import { render, staticRenderFns } from "./DeliveryInstructions.vue?vue&type=template&id=0420d52a&"
import script from "./DeliveryInstructions.vue?vue&type=script&lang=js&"
export * from "./DeliveryInstructions.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInstructions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports